import cx from 'classnames';
import { IconLoadingLogo } from '@/shared/ui/Icons';

type LoadMoreProps = {
  title: string;
  className?: string;
}

const LoadMore = (props: LoadMoreProps) => {
  const {
    title = '',
    className = '',
  } = props;

  return (
    <div className={cx(className, 'flex items-center w-full justify-center')}>
      <IconLoadingLogo className="h-4 w-4 mr-2"/>
      <span className='text-white/[0.3] text-sm'>{title}</span>
    </div>
  );
}

export default LoadMore;
